// Form validation for Custom Field form
import { plaintextValidator } from '../fields';

const config = { mandatory: true };

const optionsField = ['RADIO', 'CHECKBOX', 'SELECT', 'MULTI_SELECT'];

export const multiSelectOptionValidator = (config = { mandatory: true }) => {
  const { optionsTotalLength, optionMaxLength, mandatory, emptyError } = config;
  return {
    presence: mandatory && {
      allowEmpty: !mandatory,
      message: emptyError && `^${emptyError}`
    },
    length: optionsTotalLength && {
      maximum: optionsTotalLength,
      tooLong: `^Cannot give more than ${optionsTotalLength} options`
    },
    array: optionMaxLength && {
      value: {
        length: {
          maximum: optionMaxLength,
          tooLong: `^Option should be of length ${optionMaxLength}`
        }
      }
    }
  };
};

export default (field, optionsTotalLength, optionMaxLength) => {
  if (optionsField?.includes(field)) {
    return {
      label: plaintextValidator(config),
      options: multiSelectOptionValidator({
        ...config,
        optionsTotalLength,
        optionMaxLength
      })
    };
  }
  return {
    label: plaintextValidator(config)
  };
};
